import {useEffect,useRef} from 'react';
// Clear rendered records after inactivity; the API independently enforces its session timeout.
export default function useIdleLogout(active,onIdle){
 const callback=useRef(onIdle);callback.current=onIdle;
 useEffect(()=>{if(!active)return;let timer;const reset=()=>{clearTimeout(timer);timer=setTimeout(()=>callback.current(),30*60*1000);};const events=['pointerdown','keydown','scroll','touchstart'];events.forEach(e=>window.addEventListener(e,reset,{passive:true}));reset();return()=>{clearTimeout(timer);events.forEach(e=>window.removeEventListener(e,reset));};},[active]);
}
